import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useIsDesktop() {
  const $ = _c(2);
  const [isDesktop, setIsDesktop] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const hoverMediaQuery = window.matchMedia("(hover: hover)");
      setIsDesktop(hoverMediaQuery.matches);
      const checkIsDesktop = () => {
        setIsDesktop(hoverMediaQuery.matches);
      };
      hoverMediaQuery.addEventListener("change", checkIsDesktop);
      return () => {
        hoverMediaQuery.removeEventListener("change", checkIsDesktop);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isDesktop;
}